import {Message} from 'primeng/api';
import {MessageService} from 'primeng/api';
import { Injectable, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Injectable()
export class MessagesService {
    public messages = [];
    public error = false;
    public toastDurationValue = 5000;
    private sticky: boolean = true;
    errorUpdated: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(protected messageService: MessageService, private translate: TranslateService) {
        this.setError(false);
        this.errorUpdated.subscribe((test) => {

        })
    }

    public setToastDuration(aDuration) {
        this.toastDurationValue = parseInt(aDuration);
        if (this.toastDurationValue === 0) {
            this.sticky = true;
        } else {
            this.sticky = false;
        }
    }

    public addInfo(aMessage) {
        this.add({severity: 'info', sticky: false, summary: 'Message', detail: aMessage});
     }

    public addSuccess(aMessage) {
        this.add({severity: 'success', sticky: false, summary: 'Message', detail: aMessage});
     }

     public addErrorMsg(aMessage, aSummary = 'Message') {
        this.add({severity: 'error', sticky: this.sticky, summary: aSummary, detail: aMessage});
     }

     public addErrorNoStick(aMessage) {
        this.add({severity: 'error', sticky: false, summary: 'Message', detail: aMessage});
     }

     public addWarnNoStick(aMessage) {
        this.add({severity: 'warn', sticky: false, summary: 'Message', detail: aMessage });
     }

     public addWarn(aMessage) {
        this.add({severity: 'warn', sticky: this.sticky, summary: 'Message', detail: aMessage });
     }

    public addNotify(aMessage, aNotify) {
        if (aNotify.stateNotif === 7) {
            this.add({key: 'notify', severity: 'error', sticky: this.sticky, summary: 'Message', detail: aMessage, data: aNotify});
        } else {
            this.add({key: 'notify', severity: 'info', sticky: this.sticky, summary: 'Message', detail: aMessage, data: aNotify});
        }
    }

    public clearMessage(aKey) {
        this.messageService.clear(aKey);
    }

    public add(message: Message ) {
        message.life = this.toastDurationValue;
        this.messageService.add(message);
    }

    public addList(errorList) {
        this.messageService.addAll(errorList);
    }

    public addError(error, key) {   
        this.setError(true);
        try  {
            if (error.pattern) {
                if (key.pattern !== '') {
                    this.add({severity: 'error', sticky: this.sticky, summary: 'Erreur', detail: this.translate.instant('Ctrl_Ent', {param1: key.label , param2: key.pattern})});
                } else {
                    this.add({severity: 'error', sticky: this.sticky, summary: 'Erreur', detail: this.translate.instant('Ctrl_Ent_1', {param1: key.label})});
                }
            };
            if (error.required) {
                this.add({severity: 'error', sticky: this.sticky, summary: 'Erreur', detail: this.translate.instant('Ctrl_Ent_2', {param1: key.label})});
            };
            if (error.minlength) {
                this.add({severity: 'error', sticky: this.sticky, summary: 'Erreur', detail: this.translate.instant('Ctrl_Ent_3', {param1: key.label , param2: error.minlength.requiredLength})});
            };
            if (error.maxlength) {
                this.add({severity: 'error', sticky: this.sticky, summary: 'Erreur', detail: this.translate.instant('Ctrl_Ent_4', {param1: key.label , param2: error.maxlength.requiredLength})});
            };
            if (error.min) {
                this.add({severity: 'error', sticky: this.sticky, summary: 'Erreur', detail: this.translate.instant('Ctrl_Ent_5', {param1: key.label , param2: error.min.min})});
            };
            if (error.max) {
                this.add({severity: 'error', sticky: this.sticky, summary: 'Erreur', detail: this.translate.instant('Ctrl_Ent_6', {param1: key.label , param2: error.max.max})});
            };
            if (error.status || error.status !== null) {
                if (error.status === 400 || error.status === 404) {
                    if (!error.error.messages.errors.body) {
                        error.error = JSON.parse(error.error);
                    }
                    this.add({
                        severity: 'error', summary: 'Erreur API',
                        sticky: this.sticky,
                        detail: error.error.messages.errors.body
                    });
                } else if (error.status === 0 || error.status) {
                    this.add({ severity: 'error', summary: 'Erreur API',
                    sticky: this.sticky,
                    detail: this.translate.instant('Error')});
                }
            }
        } catch (error) {
            this.add({
                severity: 'error', summary: 'Problème',
                sticky: this.sticky,
                detail: this.translate.instant('Error')
            });
        }
    }

    setError(_error) {
        this.error = _error;
        this.errorUpdated.emit(this.error);
    }

    getError() {
        return this.errorUpdated;
    }


}
